/**
+ * JSON Schema for user events query object.
+ *
+ * http://json-schema.org/
+ */
export default {
  id: "/Events",
  type: "object",
  properties: {
    event_type: {
      type: "string",
      enum: ["media.detail_page", "media.watch", "media.wish_list"],
      required: true
    },
    media_details: {
      type: "object",
      properties: {
        action: {
          type: "string",
          required: true
        },
        media_id: {
          type: "string",
          required: true
        },
        module_id: {
          type: ["string", "number"],
          required: false
        },
        value: {
          // TODO Find a better approach to validate this, because despite being a string, it accepts "NaN" but it must be a numeric value in string format
          type: "string",
          required: false
        }
      }
    }
  }
};
